import { RecordColorEnum } from '../../../shared/enums/record-color.enum';
import { AssetReservationStatusEnum } from '../enums/asset-reservation-status.enum';

/**
 * Maps the status value to a color value which is used to style the record pill in the UI
 */
export function assetReservationStatusToColor(
	status: AssetReservationStatusEnum,
): string {
	switch (status) {
		case AssetReservationStatusEnum.PENDING:
			return RecordColorEnum.AMBER;

		case AssetReservationStatusEnum.ACCEPTED:
			return RecordColorEnum.GREEN;

		case AssetReservationStatusEnum.REJECTED:
			return RecordColorEnum.RED;

		case AssetReservationStatusEnum.CANCELLED:
			return RecordColorEnum.SLATE;

		default:
			return RecordColorEnum.DEFAULT;
	}
}
